module.exports = __webpack_public_path__ + "static/media/realcomary.8a44ca84.webp";